import React from 'react';
import type { FormikErrors, FormikValues } from 'formik';
import { ErrorBanner } from '../ErrorBanner';

export interface ErrorBannerProps {
	message: string;
	detail?: string;
	errors?: Record<string, string[]> | FormikErrors<FormikValues>;
	errorActionText?: string;
	errorAction?: () => void;
}

function flattenErrors(errors: unknown): string[] {
	if (typeof errors === 'string') return [errors];
	if (Array.isArray(errors)) return errors.flatMap(flattenErrors);
	if (errors && typeof errors === 'object') return Object.values(errors).flatMap(flattenErrors);
	return [];
}

export function FormError({ message, detail, errors, errorActionText, errorAction }: ErrorBannerProps) {
	const flattenedErrors = flattenErrors(errors || {});
	const displayErrors = () => {
		if (flattenedErrors.length > 0) {
			return (
				<ul className="list-inside list-disc">
					{flattenedErrors.map((msg, i: number) => (
						<li key={i} className="text-sm text-red-700">
							{typeof msg === 'string' ? msg : JSON.stringify(msg)}
						</li>
					))}
				</ul>
			);
		} else if (detail) {
			return <p className="text-sm text-red-700">{detail}</p>;
		}
		return null;
	};

	return (
		<ErrorBanner message={message}>
			{displayErrors()}
			{errorAction && errorActionText && (
				<button type="button" onClick={errorAction} className="mt-3 text-sm font-medium text-red-700 underline hover:text-red-900">
					{errorActionText}
				</button>
			)}
		</ErrorBanner>
	);
}
